import React from 'react';
import useProgramConfig from '../useProgramConfig.js';

export default function withProgramConfig(Component) {
  return function WrapperComponent(props) {
    const programConfig = useProgramConfig();
    return <Component {...props} programConfig={programConfig} />;
  };
}
